import React from 'react';
import { getFlagUrl } from '../data/countries.js';

export default function NationsPanel({ stats, visible, onClose }) {
  if (!visible) return null;

  const nations = Object.entries(stats.nationalities || {})
    .sort(([, a], [, b]) => b - a);

  return (
    <div className="np-panel" data-testid="nations-panel">
      <div className="np-header">
        <span className="np-title">
          Active Nations
          <span className="np-count">{nations.length}</span>
        </span>
        <button className="np-close" data-testid="nations-panel-close" onClick={onClose}>✕</button>
      </div>

      <div className="np-total">
        <span className="np-total-label">Total Grains</span>
        <span className="np-total-num" data-testid="np-total">{stats.total.toLocaleString()}</span>
      </div>

      {nations.length === 0 ? (
        <div className="np-empty">No nations yet — be the first!</div>
      ) : (
        <div className="np-list" data-testid="nations-list">
          {nations.map(([nat, cnt], i) => {
            const url = getFlagUrl(nat);
            return (
              <div key={nat} className="np-row" data-testid={`np-row-${nat}`}>
                <span className="np-rank">#{i + 1}</span>
                {url && <img src={url} alt={nat} className="np-flag" />}
                <span className="np-name">{nat}</span>
                <span className="np-cnt">{cnt.toLocaleString()}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
